import React, { Component, DetailedHTMLProps, HTMLAttributes } from 'react';
import { CMXIcon } from '@codametrix/ui-components';

// Define a type for the props
type InvoiceMetadataProps = {
  dateOfService: string;
  department: string;
  performingName: string;
  providerName: string;
  referringName: string;
  editable: boolean;
  codableInvoice?: CMxCommonApp.CodableInvoice; // Specify a more accurate type if possible
  onInvoiceMetaEdit: (codableInvoice: any) => void; // Specify a more accurate type for codableInvoice if possible
};

// Define the component
class InvoiceMetadata extends Component<InvoiceMetadataProps> {
  render() {
    const {
      dateOfService,
      department,
      performingName,
      providerName,
      referringName,
      editable,
      codableInvoice,
      onInvoiceMetaEdit
    } = this.props;

    return (
      <div className="invoice-meta-row">
        <div className="invoice-meta-cell-date">
          <p className="invoice-meta-date_of_service">{dateOfService}</p>
        </div>
        <div className="invoice-meta-cell-providers">
          {department && (
            <p className="invoice-meta-department_name">
              <span className="invoice-meta-label">Department:</span>{' '}
              {department}
            </p>
          )}
          {performingName && (
            <p className="invoice-meta-performing_name">
              <span className="invoice-meta-label">Performed by:</span>{' '}
              {performingName}
            </p>
          )}
          {providerName && (
            <p className="invoice-meta-provider_name">
              <span className="invoice-meta-label">Billing provider:</span>{' '}
              {providerName}
            </p>
          )}
          {referringName && (
            <p className="invoice-meta-referring_name">
              <span className="invoice-meta-label">Referred by:</span>{' '}
              {referringName}
            </p>
          )}
        </div>
        <div className="invoice-meta-cell-actions">
          {editable && codableInvoice && (
            <span className="invoice-edit">
              <a
                href="#/change-session"
                onClick={(e) => {
                  e.preventDefault();
                  if (codableInvoice) {
                    onInvoiceMetaEdit(codableInvoice);
                  }
                }}>
                <CMXIcon
                  svgIconName="BiomeEdit"
                  svgIconSize="16"
                  svgTitleText="Edit invoice"
                  svgIconClass="invoice-edit-icon"
                />
              </a>
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default InvoiceMetadata;
